import { on } from "@ember/modifier";
import PluginOutlet from "discourse/components/plugin-outlet";
import TopicListHeaderColumn from "discourse/components/topic-list/topic-list-header-column";
import icon from "discourse-common/helpers/d-icon";
import i18n from "discourse-common/helpers/i18n";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
import templateOnly from "@ember/component/template-only";
const TopicListHeader = setComponentTemplate(createTemplateFactory(
/*
  
  <tr>
    <PluginOutlet @name="topic-list-header-before" />

    {{#if @bulkSelectEnabled}}
      <th class="bulk-select topic-list-data">
        {{#if @canBulkSelect}}
          <button
            {{on "click" @bulkSelectHelper.toggleBulkSelect}}
            title={{i18n "topics.bulk.toggle"}}
            class="btn-flat bulk-select"
          >
            {{icon (if @experimentalTopicBulkActionsEnabled "tasks" "list")}}
          </button>
        {{/if}}
      </th>
    {{/if}}

    <TopicListHeaderColumn
      @order="default"
      @category={{@category}}
      @activeOrder={{@order}}
      @changeSort={{@changeSort}}
      @ascending={{@ascending}}
      @name={{@listTitle}}
      @bulkSelectEnabled={{@bulkSelectEnabled}}
      @showBulkToggle={{@toggleInTitle}}
      @canBulkSelect={{@canBulkSelect}}
      @canDoBulkActions={{@canDoBulkActions}}
      @showTopicsAndRepliesToggle={{@showTopicsAndRepliesToggle}}
      @newListSubset={{@newListSubset}}
      @newRepliesCount={{@newRepliesCount}}
      @newTopicsCount={{@newTopicsCount}}
      @experimentalTopicBulkActionsEnabled={{@experimentalTopicBulkActionsEnabled}}
      @bulkSelectHelper={{@bulkSelectHelper}}
      @changeNewListSubset={{@changeNewListSubset}}
    />

    <PluginOutlet @name="topic-list-header-after-main-link" />

    {{#if @showPosters}}
      <TopicListHeaderColumn
        @order="posters"
        @activeOrder={{@order}}
        @changeSort={{@changeSort}}
        @ascending={{@ascending}}
        aria-label={{i18n "category.sort_options.posters"}}
      />
    {{/if}}

    <TopicListHeaderColumn
      @sortable={{@sortable}}
      @number="true"
      @order="posts"
      @activeOrder={{@order}}
      @changeSort={{@changeSort}}
      @ascending={{@ascending}}
      @name="replies"
      aria-label={{i18n "sr_replies"}}
    />

    {{#if @showLikes}}
      <TopicListHeaderColumn
        @sortable={{@sortable}}
        @number="true"
        @order="likes"
        @activeOrder={{@order}}
        @changeSort={{@changeSort}}
        @ascending={{@ascending}}
        @name="likes"
        aria-label={{i18n "sr_likes"}}
      />
    {{/if}}

    {{#if @showOpLikes}}
      <TopicListHeaderColumn
        @sortable={{@sortable}}
        @number="true"
        @order="op_likes"
        @activeOrder={{@order}}
        @changeSort={{@changeSort}}
        @ascending={{@ascending}}
        @name="likes"
        aria-label={{i18n "sr_op_likes"}}
      />
    {{/if}}

    <TopicListHeaderColumn
      @sortable={{@sortable}}
      @number="true"
      @order="views"
      @activeOrder={{@order}}
      @changeSort={{@changeSort}}
      @ascending={{@ascending}}
      @name="views"
      aria-label={{i18n "sr_views"}}
    />

    <TopicListHeaderColumn
      @sortable={{@sortable}}
      @number="true"
      @order="activity"
      @activeOrder={{@order}}
      @changeSort={{@changeSort}}
      @ascending={{@ascending}}
      @name="activity"
      aria-label={{i18n "sr_activity"}}
    />

    <PluginOutlet @name="topic-list-header-after" />
  </tr>

*/
{
  "id": "odeziGba",
  "block": "[[[1,\"\\n  \"],[10,\"tr\"],[12],[1,\"\\n    \"],[8,[32,0],null,[[\"@name\"],[\"topic-list-header-before\"]],null],[1,\"\\n\\n\"],[41,[30,1],[[[1,\"      \"],[10,\"th\"],[14,0,\"bulk-select topic-list-data\"],[12],[1,\"\\n\"],[41,[30,2],[[[1,\"          \"],[11,\"button\"],[16,\"title\",[28,[32,1],[\"topics.bulk.toggle\"],null]],[24,0,\"btn-flat bulk-select\"],[4,[32,2],[\"click\",[30,3,[\"toggleBulkSelect\"]]],null],[12],[1,\"\\n            \"],[1,[28,[32,3],[[52,[30,4],\"tasks\",\"list\"]],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[8,[32,4],null,[[\"@order\",\"@category\",\"@activeOrder\",\"@changeSort\",\"@ascending\",\"@name\",\"@bulkSelectEnabled\",\"@showBulkToggle\",\"@canBulkSelect\",\"@canDoBulkActions\",\"@showTopicsAndRepliesToggle\",\"@newListSubset\",\"@newRepliesCount\",\"@newTopicsCount\",\"@experimentalTopicBulkActionsEnabled\",\"@bulkSelectHelper\",\"@changeNewListSubset\"],[\"default\",[30,5],[30,6],[30,7],[30,8],[30,9],[30,1],[30,10],[30,2],[30,11],[30,12],[30,13],[30,14],[30,15],[30,4],[30,3],[30,16]]],null],[1,\"\\n\\n    \"],[8,[32,0],null,[[\"@name\"],[\"topic-list-header-after-main-link\"]],null],[1,\"\\n\\n\"],[41,[30,17],[[[1,\"      \"],[8,[32,4],[[16,\"aria-label\",[28,[32,1],[\"category.sort_options.posters\"],null]]],[[\"@order\",\"@activeOrder\",\"@changeSort\",\"@ascending\"],[\"posters\",[30,6],[30,7],[30,8]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[8,[32,4],[[16,\"aria-label\",[28,[32,1],[\"sr_replies\"],null]]],[[\"@sortable\",\"@number\",\"@order\",\"@activeOrder\",\"@changeSort\",\"@ascending\",\"@name\"],[[30,18],\"true\",\"posts\",[30,6],[30,7],[30,8],\"replies\"]],null],[1,\"\\n\\n\"],[41,[30,19],[[[1,\"      \"],[8,[32,4],[[16,\"aria-label\",[28,[32,1],[\"sr_likes\"],null]]],[[\"@sortable\",\"@number\",\"@order\",\"@activeOrder\",\"@changeSort\",\"@ascending\",\"@name\"],[[30,18],\"true\",\"likes\",[30,6],[30,7],[30,8],\"likes\"]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,20],[[[1,\"      \"],[8,[32,4],[[16,\"aria-label\",[28,[32,1],[\"sr_op_likes\"],null]]],[[\"@sortable\",\"@number\",\"@order\",\"@activeOrder\",\"@changeSort\",\"@ascending\",\"@name\"],[[30,18],\"true\",\"op_likes\",[30,6],[30,7],[30,8],\"likes\"]],null],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[8,[32,4],[[16,\"aria-label\",[28,[32,1],[\"sr_views\"],null]]],[[\"@sortable\",\"@number\",\"@order\",\"@activeOrder\",\"@changeSort\",\"@ascending\",\"@name\"],[[30,18],\"true\",\"views\",[30,6],[30,7],[30,8],\"views\"]],null],[1,\"\\n\\n    \"],[8,[32,4],[[16,\"aria-label\",[28,[32,1],[\"sr_activity\"],null]]],[[\"@sortable\",\"@number\",\"@order\",\"@activeOrder\",\"@changeSort\",\"@ascending\",\"@name\"],[[30,18],\"true\",\"activity\",[30,6],[30,7],[30,8],\"activity\"]],null],[1,\"\\n\\n    \"],[8,[32,0],null,[[\"@name\"],[\"topic-list-header-after\"]],null],[1,\"\\n  \"],[13],[1,\"\\n\"]],[\"@bulkSelectEnabled\",\"@canBulkSelect\",\"@bulkSelectHelper\",\"@experimentalTopicBulkActionsEnabled\",\"@category\",\"@order\",\"@changeSort\",\"@ascending\",\"@listTitle\",\"@toggleInTitle\",\"@canDoBulkActions\",\"@showTopicsAndRepliesToggle\",\"@newListSubset\",\"@newRepliesCount\",\"@newTopicsCount\",\"@changeNewListSubset\",\"@showPosters\",\"@sortable\",\"@showLikes\",\"@showOpLikes\"],false,[\"if\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/topic-list/topic-list-header.js",
  "scope": () => [PluginOutlet, i18n, on, icon, TopicListHeaderColumn],
  "isStrictMode": true
}), templateOnly());
export default TopicListHeader;